import { Injectable } from '@angular/core';
import { HttpClientService } from '../implementacion/http-client.service';

import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient as Http, HttpParams } from '@angular/common/http';
import { DatosGenerales } from 'src/app/models/SicarMap/BusquedaNisOUC/DatosGenerales.model';
import { Subject } from 'rxjs';
import { MedidorConsumos } from 'src/app/models/SicarMap/BusquedaNisOUC/MedidorConsumos.model';
import { Deuda } from 'src/app/models/SicarMap/BusquedaNisOUC/Deuda.model';
import { Cobros } from 'src/app/models/SicarMap/BusquedaNisOUC/Cobros.model';
import { OrdenesTrabajo } from 'src/app/models/SicarMap/BusquedaNisOUC/OrdenesTrabajo.model';
import { PQRS } from 'src/app/models/SicarMap/BusquedaNisOUC/Pqrs.model';
import { ListPQRS } from 'src/app/models/SicarMap/BusquedaNisOUC/ListPQRS.model';
import { AvisosAverias } from 'src/app/models/SicarMap/BusquedaNisOUC/AvisosAverias.model';
import { Respuesta } from 'src/app/models/SicarMap/BusquedaNisOUC/Respuesta.model';
import { OUCColonia } from 'src/app/models/SicarMap/BusquedaNisOUC/OUCColonias.model';
import { OUCColoniaM } from 'src/app/models/SicarMap/BusquedaNisOUC/OUCColoniaM.model';
import { OUCCalle } from 'src/app/models/SicarMap/BusquedaNisOUC/OUCCalle.model';
import { OUCCalleM } from 'src/app/models/SicarMap/BusquedaNisOUC/OUCCalleM.model';
import { Options } from 'selenium-webdriver';
import { HttpHeaders } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})

export class BusquedaNissService {
  URLApi: string;
  key: string;
  Secret: string;
  type: string;
  user: string;
  pass: string;
  scope: string;
  typeToken: string;
  tokenConsulta: string;

  URLApiEG: string;
  keyEG: string;
  SecretEG: string;
  typeEG: string;
  userEG: string;
  passEG: string;
  scopeEG: string;
  typeTokenEG: string;
  tokenConsultaEG: string;


  public V_DatosGenerales = new Subject<DatosGenerales>();
  public V_MedidorConsumosLecturas = new Subject<MedidorConsumos>();
  public V_Deuda = new Subject<Deuda>();
  public V_Cobros = new Subject<Cobros>();
  public V_OrdenesTrabajo = new Subject<OrdenesTrabajo>();
  public V_PQRS = new Subject<ListPQRS>();
  public V_AvisosAverias = new Subject<AvisosAverias>();

  constructor(
    private http: HttpClientService,
    private httpD: Http) { }

  getDatosNiss(Niss: number) {
    return this.http.get(`${environment.apiScar}DatosNISS/ObtenerDatosNISS?NISS=${Niss}`)
      .pipe(map(response => response));
  }

  getDatosDatosGenerales(NIS: string) {
    return this.httpD.get<DatosGenerales>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getMedidorConsumosLecturas(NIS: string) {
    return this.httpD.get<MedidorConsumos>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/meter`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getDeuda(NIS: string) {
    return this.httpD.get<Deuda>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/bills`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getCobros(NIS: string) {
    return this.httpD.get<Cobros>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/billCollections`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getOrdenesTrabajo(NIS: string) {
    return this.httpD.get<OrdenesTrabajo>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/workOrders`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getPqrs(NIS: string) {
    return this.httpD.get<ListPQRS>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/pqrs`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  getAvisosAverias(NIS: string) {
    return this.httpD.get<AvisosAverias>(`${this.URLApi}/adpsectorsupply/1.0.1/${NIS}/outage`, { headers: this.generarHeadersOUC() })
      .pipe(map(response => response));
  }

  setCalle(datosCalles: any) {

  }

  getTokenConsulta() {
    return this.httpD.post(`${this.URLApi}/token`, this.generarParamsTokenOUC(), { headers: this.generarHeadersTokenOUC() })
      .pipe(map(response => response));
  }

  getTokenEG() {
    return this.httpD.post(`${this.URLApiEG}/token`, this.generarParamsTokenOUC_EG(), { headers: this.generarHeadersTokenOUC_EG() })
      .pipe(map(response => response));
  }

  generarHeadersOUC() {
    let token = this.generarToken();
    const headersG = { 'Authorization': `${this.typeToken} ${this.tokenConsulta}` };
    return headersG;
  }

  generarHeadersOUC_EG() {
    let token = this.generarTokenEG();
    const headersG = { 'Authorization': `${this.typeTokenEG} ${this.tokenConsultaEG}` };
    return headersG;
  }

  generarHeadersOUC_EG_Eliminar() {
    let token = this.generarTokenEG();
    const headersG = { 'Authorization': `${this.typeTokenEG} ${this.tokenConsultaEG}`, 'Content-Type': 'application/json' };
    return headersG;
  }

  generarToken() {
    let basicAuthHeader = this.key + ":" + this.Secret;
    let base64Encoded = btoa(basicAuthHeader);
    return base64Encoded;
  }

  generarTokenEG() {
    let basicAuthHeader = this.keyEG + ":" + this.SecretEG;
    let base64Encoded = btoa(basicAuthHeader);
    return base64Encoded;
  }

  generarHeadersTokenOUC() {
    let token = this.generarToken();
    const headersG = { 'Content-Type': 'application/x-www-form-urlencoded' };
    headersG['authorization'] = `Basic ${token}`;
    return headersG;
  }

  generarHeadersTokenOUC_EG() {
    let token = this.generarTokenEG();
    const headersG = { 'Content-Type': 'application/x-www-form-urlencoded' };
    headersG['authorization'] = `Basic ${token}`;
    return headersG;
  }

  generarParamsTokenOUC() {
    let body = `grant_type=${this.type}&username=${this.user}&password=${this.pass}&scope=${this.scope}`;
    return body;
  }

  generarParamsTokenOUC_EG() {
    let body = `grant_type=${this.typeEG}&username=${this.userEG}&password=${this.passEG}&scope=${this.scopeEG}`;
    return body;
  }

  setDatosApiOUC(configuracion) {
    this.URLApi = configuracion.find(x => x.servicio == "Url_Api").urlServicio;
    this.key = configuracion.find(x => x.servicio == "key").urlServicio;
    this.Secret = configuracion.find(x => x.servicio == "customer-secret").urlServicio;
    this.type = configuracion.find(x => x.servicio == "type").urlServicio;
    this.user = configuracion.find(x => x.servicio == "user").urlServicio;
    this.pass = configuracion.find(x => x.servicio == "pass").urlServicio;
    this.scope = configuracion.find(x => x.servicio == "scope").urlServicio;


    this.URLApiEG = configuracion.find(x => x.servicio == "Url_Api_EG").urlServicio;
    this.keyEG = configuracion.find(x => x.servicio == "key_EG").urlServicio;
    this.SecretEG = configuracion.find(x => x.servicio == "customer-secret_EG").urlServicio;
    this.typeEG = configuracion.find(x => x.servicio == "type_EG").urlServicio;
    this.userEG = configuracion.find(x => x.servicio == "user_EG").urlServicio;
    this.passEG = configuracion.find(x => x.servicio == "pass_EG").urlServicio;
    this.scopeEG = configuracion.find(x => x.servicio == "scope_EG").urlServicio;
  }

  AgregarColonia(Colonia: OUCColonia) {
    return this.httpD.post<Respuesta>(`${this.URLApi}/geographical/1.0.1/entity`, Colonia, { headers: this.generarHeadersOUC_EG() })
      .pipe(map(response => response));
  }

  ModificarColonia(code: string, ColoniaM: OUCColoniaM) {
    return this.httpD.patch<Respuesta>(`${this.URLApi}/geographical/1.0.1/entity/` + code, ColoniaM, { headers: this.generarHeadersOUC_EG() })
      .pipe(map(response => response));
  }

  EliminarColonia(code: string) {
    const options = {
      headers: new HttpHeaders(this.generarHeadersOUC_EG_Eliminar()),
      body: {}
    }
    //let options = new RequestOptions({});
    return this.httpD.delete<Respuesta>(`${this.URLApi}/geographical/1.0.1/entity/` + code, options)
      .pipe(map(response => response));
  }

  AgregarCalle(Calle: OUCCalle) {
    return this.httpD.post<Respuesta>(`${this.URLApi}/geographical/1.0.1/street`, Calle, { headers: this.generarHeadersOUC_EG() })
      .pipe(map(response => response));
  }

  ModificarCalle(code: string, CalleM: OUCCalleM) {
    return this.httpD.patch<Respuesta>(`${this.URLApi}/geographical/1.0.1/street/` + code, CalleM, { headers: this.generarHeadersOUC_EG() })
      .pipe(map(response => response));
  }

  EliminarCalle(code: string) {
    const options = {
      headers: new HttpHeaders(this.generarHeadersOUC_EG_Eliminar()),
      body: {}
    }
    return this.httpD.delete<Respuesta>(`${this.URLApi}/geographical/1.0.1/street/` + code, options)
      .pipe(map(response => response));
  }


  ObtenerClaveColonia() {
    return this.http.get(`${environment.apiScar}DatosNISS/ObtenerClaveColonia`)
      .pipe(map(response => response));
  }

  ObtenerClaveCalle() {
    return this.http.get(`${environment.apiScar}DatosNISS/ObtenerClaveCalle`)
      .pipe(map(response => response));
  }

  ObtenerTiposVias() {
    return this.http.get(`${environment.apiScar}DatosNISS/ObtenerTiposVias`)
      .pipe(map(response => response));
  }

}
